/*
 * @deprecated
 * **/

import {
  Checkbox,
  Divider,
  Input,
  Pagination,
  PaginationProps,
  Popover,
  Select,
  Spin,
  Table,
  TableColumnsType,
  Tooltip,
} from "antd";
import { FC, useEffect, useState } from "react";
import {
  BsArrowDownShort,
  BsArrowUpShort,
  BsEraserFill,
  BsFilterRight,
} from "react-icons/bs";
import { AnyObject } from "yup";
import Actions from "../Actions/Actions";
import { ActionsKey } from "../../models/Actions";
import { ColumnItem } from "../../models/table";
import { LoadingOutlined } from "@ant-design/icons";

type ChangePageType = {
  itemsPerPage: number;
  page: number;
};

type PaginationType = {
  defaultCurrentPage?: number;
  totalItems?: number;
  itemsPerPage?: number;
};

type Other = {
  onClick?: Function;
  id?: number | string;
  row?: any;
};

type LFTableProps = {
  columns: ColumnItem[];
  data: AnyObject[];
  permissions: Array<ActionsKey>;
  onAction: (item: any, action: ActionsKey) => void;
  sort?: { dataKey: string; order?: "asc" | "desc" } | null;
  onSearch?: (search: { searchStr: string; dataKey: string }) => void;
  onSort?: (order: { dataKey: string; order?: "asc" | "desc" } | null) => void;
  onResetSearch?: () => void;
  onChangePage: (e: ChangePageType) => void;
  pagination?: PaginationType;
  params?: any;
  isLoading?: boolean;
  otherActions?: FC<Other>[];
};

export const LFTableV2 = ({
  columns,
  data,
  permissions,
  onAction,
  onSearch,
  onSort,
  onResetSearch,
  pagination,
  onChangePage,
  params,
  isLoading,
  otherActions,
}: LFTableProps) => {
  const searchRefs: any[] = [];

  const [openCol, setOpenCol] = useState<boolean>(false);
  const [timeoutId, setTimeoutId] = useState<any>(null);
  const [sort, setSort] = useState<any>(null);
  const [isHavingSearch, setIsHavingSearch] = useState<boolean>(false);

  let cols: ColumnItem[] = columns;

  useEffect(() => {
    return () => onResetSearch && onResetSearch();
  }, []);

  useEffect(() => {
    setIsHavingSearch(
      cols.some((item) => item.searchType !== "none" && item.searchType)
    );
  }, [cols]);

  useEffect(() => {
    const order = {
      ...params,
      order: sort ?? { dataKey: "id", order: "desc" },
    };

    onSort && onSort(formatParams(order));
  }, [sort]);

  /**
   * Search logic
   * Wait 500ms after typing before call API
   */

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const onTypingOnSearch = (value: any) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const id = setTimeout(() => {
      onSearch && onSearch({ ...params, page: 1, ...value });
    }, 500);
    setTimeoutId(id);
  };

  /**End Search logic */

  const formatParams = (defaultParams: any) => {
    const obj: any = { ...defaultParams, order: null };

    Object.keys(defaultParams).forEach((key) => {
      if (key?.includes("order")) {
        delete obj[key];
      }
    });
    Object.keys(defaultParams).forEach((key: any) => {
      if (key === "order") {
        obj["order[" + (defaultParams?.order?.dataKey ?? "") + "]"] =
          defaultParams?.order?.order;
      } else {
        obj[key] = obj[key]?.toString();
      }
    });
    delete obj["order"];
    return obj;
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpenCol(newOpen);
  };

  const showTotal: PaginationProps["showTotal"] = (total: number) =>
    `Total ${total}`;

  /**
   * Columns
   */
  const col2show: TableColumnsType<AnyObject> = [
    {
      key: "",
      title: () => {
        return (
          <div className="">
            {isHavingSearch ? (
              <div
                style={{ height: 31 }}
                className="p-1 d-flex justify-content-start px-2"
              >
                <Tooltip title={"Effacer"}>
                  <div
                    className=" cursor-pointer "
                    onClick={() => {
                      searchRefs?.forEach((input) => {
                        if (input && input?.current) {
                          input.current.value = "";
                        } else if (input && input?.value) {
                          input.value = "";
                        }
                      });
                      if (onResetSearch) {
                        onResetSearch();
                      }
                    }}
                  >
                    <BsEraserFill size={18} />
                  </div>
                </Tooltip>
              </div>
            ) : (
              ""
            )}
            <div className="d-flex align-items-center justify-content-between p-2 w-100">
              <Tooltip title={"Afficher/Cacher"}>
                <Popover
                  open={openCol}
                  trigger={"click"}
                  placement="bottomLeft"
                  onOpenChange={handleOpenChange}
                  content={() => {
                    let allChecked: boolean = true;
                    cols?.forEach((cd) => {
                      if (!cd?.show) {
                        allChecked = false;
                      }
                    });
                    return (
                      <div>
                        <div>
                          <div>
                            <Checkbox
                              checked={allChecked}
                              onChange={(e) => {
                                let newCols = [...cols];
                                if (allChecked) {
                                  newCols.forEach((ne, ie) => {
                                    newCols[ie].show = false;
                                  });
                                } else {
                                  newCols.forEach((ne, ie) => {
                                    newCols[ie].show = true;
                                  });
                                }
                                cols = newCols;
                                setOpenCol(false);
                              }}
                            >
                              <span className="ms-2">Tout</span>
                            </Checkbox>
                          </div>
                        </div>
                        <Divider className="my-2" />
                        {cols?.map((cop: any, ik: any) => {
                          return (
                            <div className="d-flex">
                              <Checkbox
                                checked={cop?.show}
                                onChange={(e) => {
                                  let newCols = [...cols];
                                  newCols[ik].show = !cols[ik].show;
                                  cols = newCols;
                                  setOpenCol(false);
                                }}
                              >
                                <span className="ms-2">{cop?.title}</span>
                              </Checkbox>
                            </div>
                          );
                        })}
                      </div>
                    );
                  }}
                >
                  <div
                    className="p-0 cursor-pointer"
                    // onClick={() => setOpenCol(true)}
                  >
                    <BsFilterRight size={20} />
                  </div>
                </Popover>
              </Tooltip>
              <div className="w-full">Actions</div>
              <div className="w-full"></div>
              <div className="w-full"></div>
            </div>
          </div>
        );
      },
      render: (role, row, i) => {
        let perms: ActionsKey[] = [];
        permissions?.forEach((pe, i) => {
          if (role?.userRole?.isRequired && pe === "read") {
            perms.push(pe);
          } else {
            perms.push(pe);
          }
        });
        return (
          <div
            className={`
               d-flex  align-items-center px-4 gap-3 h-100
              ${
                i % 2 !== 0
                  ? "text-center table-row-c2 "
                  : "text-center table-row-c1"
              }
              `}
            style={{
              backgroundColor: "inherit",
            }}
          >
            {/* {permissions.includes("read") && (
              <Tooltip title={"Détails"}>
                <div
                  className=" cursor-pointer"
                  onClick={() => onAction(role, "read")}
                >
                  <HiEye />
                </div>
              </Tooltip>
            )}
            {permissions.includes("update") && (
              <Tooltip title={"Modifier"}>
                <div
                  className=" cursor-pointer"
                  onClick={() => onAction(role, "update")}
                >
                  <HiPencil />
                </div>
              </Tooltip>
            )}
            {permissions.includes("delete") && (
              <Tooltip title={"Supprimer"}>
                <div
                  className=" cursor-pointer"
                  // onClick={() => {
                  //   setDeleting(true);
                  // }}
                >
                  <IoTrashOutline />
                </div>
              </Tooltip>
            )} */}
            <Actions
              permissions={perms}
              onViewDetailClick={() => {
                onAction(role, "read");
              }}
              onUpdateClick={() => {
                onAction(role, "update");
              }}
              onDeleteClick={() => {
                onAction(role, "delete");
              }}
            />

            {otherActions &&
              Array.isArray(otherActions) &&
              otherActions.map((Other) => (
                <div className="cursor-pointer">
                  <Other id={(row as any)?.id} row={row} />
                </div>
              ))}
          </div>
        );
      },
      fixed: true,
      width: 150,
    },
  ];
  cols.forEach((col: ColumnItem) => {
    if (col?.show) {
      col2show.push({
        ...col,
        title: () =>
          // item
          {
            return (
              <div
                className={`
                  d-flex flex-column align-items-center
                  ${col?.isCanSort ? "cursor-pointer" : ""}
                  `}
                {...(col?.isCanSort
                  ? {
                      onClick: () => {
                        if (!sort && onSort) {
                          setSort({
                            dataKey: col.dataIndex ?? col?.nestedKey ?? "",
                            order: "desc",
                          });
                        } else if (
                          sort &&
                          sort?.dataKey !== col?.dataIndex &&
                          onSort
                        ) {
                          setSort({
                            dataKey: col.dataIndex ?? col?.nestedKey ?? "",
                            order: "desc",
                          });
                        } else if (sort?.order === "asc" && onSort) {
                          setSort(null);
                        } else if (sort?.order === "desc" && onSort) {
                          setSort({
                            dataKey: col.dataIndex ?? col?.nestedKey ?? "",
                            order: "asc",
                          });
                        }
                      },
                    }
                  : {})}
              >
                {isHavingSearch ? (
                  <div className="w-100 p-1">
                    {col?.searchType && col?.searchType === "text" && (
                      <>
                        <Input
                          value={params?.[col?.nestedKey ?? col?.dataIndex]}
                          style={{
                            height: 29,
                            color: "#3f3e3e",
                            fontSize: "13px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          onChange={(e) => {
                            const theText = e.target.value?.trim();
                            if (theText?.length <= 2 && !theText?.length) {
                              console.log("White space detected ");
                              return;
                            }
                            if (e.target.value?.length >= 3 && onSearch) {
                              let theKeyUse = "";
                              if (col?.nestedKey) {
                                let arr = col?.nestedKey?.split(".");
                                arr?.forEach((nest: any, ic: any) => {
                                  if (ic === 0) {
                                    theKeyUse += nest;
                                  } else {
                                    theKeyUse += "[" + nest + "]";
                                  }
                                });
                              } else {
                                theKeyUse = col?.dataIndex;
                              }
                              onTypingOnSearch({
                                [theKeyUse]: e.target.value,
                              });
                            } else if (
                              e.target.value?.length === 0 &&
                              onSearch
                            ) {
                              onTypingOnSearch({
                                [col?.nestedKey ?? col?.dataIndex]: "",
                              });
                            }
                          }}
                        />
                      </>
                    )}
                    {col?.searchType === "select" && (
                      <Select
                        className="w-100 custom-small-select"
                        style={{
                          height: 29,
                          fontSize: "13px",
                          color: "#3f3e3e",
                          backgroundColor: "#fcfcfc",
                        }}
                        size="large"
                        options={col?.searchOptions ?? []}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        value={params?.[col?.nestedKey ?? col?.dataIndex]}
                        allowClear
                        showSearch
                        loading={col?.isLoading}
                        onChange={(v) => {
                          let theKeyUse =
                            col?.nestedKey ?? col?.dataIndex ?? "";

                          if (onSearch) {
                            onTypingOnSearch({
                              [theKeyUse]: v,
                            });
                          }
                        }}
                      />
                    )}
                    {!col?.searchType || col?.searchType === "none" ? (
                      <div className="w-100" style={{ height: 31 }}></div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div className="p-1 table-title text-center w-100 h-100 d-flex align-items-center justify-content-center">
                  <span>{col?.title}</span>
                  {sort?.dataKey === col?.nestedKey ||
                  sort?.dataKey === col?.dataIndex ? (
                    <div>
                      {sort?.order === "asc" && <BsArrowUpShort />}
                      {sort?.order === "desc" && <BsArrowDownShort />}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            );
          },
      });
    }
  });
  return (
    <div className="table__wrapper">
      {isLoading ? (
        <div className="">
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      ) : (
        ""
      )}
      <div className="table">
        <Table
          columns={col2show}
          dataSource={data}
          className=""
          rowClassName={(_, i) => {
            return i % 2 !== 0
              ? "text-center  table-row-c2"
              : "text-center  table-row-c1";
          }}
          locale={{
            emptyText: "Aucune donnée",
          }}
          scroll={{ x: "max-content" }}
          pagination={false}
          rowKey="id"
        />
      </div>
      {pagination ? (
        <div className="table__pagination">
          <Pagination
            className="w-full"
            showSizeChanger
            showTotal={showTotal}
            defaultCurrent={1}
            current={pagination?.defaultCurrentPage}
            pageSize={pagination?.itemsPerPage || 10}
            total={pagination?.totalItems || 0}
            onChange={(page, itemsPerPage) => {
              onChangePage &&
                onChangePage({ page: page ?? 1, itemsPerPage: itemsPerPage });
            }}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
